import React, { useMemo } from "react";
import RadioButton from "@rio-cloud/rio-uikit/RadioButton";
import { ALL, deliverableSubTypeOptions } from "~/features/base/constants/filterOptions";
import { useSelector, useDispatch } from 'react-redux';
import { pathnameSelector, searchSelector } from "~/features/base/selectors/locationSelectors";
import { followRoute } from "~/features/base/actions/ui/routeActions";
import {
    DELIVERABLE_TYPE_BUNDLE,
    FETCH_DELIVERABLES_AMOUNT_INCREMENT
} from "~/features/deliverables/constants/deliverablesParameters";
import { parseQuery } from "~/features/base/utils/query";

interface BundleTypeTabsProps {}

interface BundleTypeOption {
    id: string;
    label: string;
}

const BundleTypes: BundleTypeOption[] = deliverableSubTypeOptions[DELIVERABLE_TYPE_BUNDLE];

const BundleTypeTabs: React.FC<BundleTypeTabsProps> = () => {
    const dispatch = useDispatch();
    const pathname = useSelector(pathnameSelector);
    const search = useSelector(searchSelector);
    const parsedQuery = useMemo(() => parseQuery(search), [search]);

    const handleChange = (item: BundleTypeOption) => {
        dispatch(followRoute({
            route: pathname,
            query: {
                ...parsedQuery,
                bundleType: item.id,
                page: 0,
                size: FETCH_DELIVERABLES_AMOUNT_INCREMENT,
            },
        }));
    };

    const isSelected = (item: BundleTypeOption) =>
        item.id === ALL && parsedQuery.bundleType === undefined || item.id === parsedQuery.bundleType;

    const getSelectedClass = (item: BundleTypeOption) =>
        isSelected(item) ? 'border-color-highlight bg-highlight-decent' : 'hover-bg-highlight-decent';

    return (
        <div className='btn-toolbar display-flex margin-bottom-20'>
            {BundleTypes.map((item) => (
                <RadioButton
                    key={item.id}
                    name='noTickRadioBoxes'
                    custom
                    style={{ borderRadius: '100px !important' }}
                    className={`padding-5 border rounded-extra-large ${getSelectedClass(item)}`}
                    onChange={() => handleChange(item)}
                    checked={isSelected(item)}
                >
                    <div className='text-center text-size-14 text-medium margin-left-5 margin-right-5'>
                        {item.label}
                    </div>
                </RadioButton>
            ))}
        </div>
    );
};

export default BundleTypeTabs;
